import axios from "axios";

interface LoginValues {
  email: string;
  password: string;
}

interface RegistrationValues {
  name: string;
  phone: string;
  email: string;
  password: string;
  role: string;
}

export const loginUser = async (values: LoginValues) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_URL}/auth/login`,
      values,
      {
        headers: {
          "X-Client-Type": "web",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const registerUser = async (values: RegistrationValues) => {
  const requestBody = {
    email: values.email,
    password: values.password,
    name: values.name,
    phone: values.phone,
    type: values.role,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_URL}/auth/register`,
      requestBody,
      {
        headers: {
          "X-Client-Type": "web",
        },
      }
    );
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error("Registration failed: " + error.message);
    } else {
      throw new Error("Unknown error occurred during registration.");
    }
  }
};
